import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestInfo, ReqMedInfo } from '../../models/RequestInfo.model';
import { VM_RequestInfo } from '../../models/VM_RequestInfo.model';
import { SummaryInfo, DataInfo, Temp } from '../../models/SummaryInfo.model';
import { AppConfig } from '../app.config.service';
import { MedicalRecordInfo } from '../../models/MedicalRecordInfo.model';

import api from '../api';

@Injectable()
export class RequestService {

  constructor(public http: HttpClient) { }

  GetManage(reqType: number, status: number, fromTime: Date, toTime: Date): Observable<Array<RequestInfo>> {
    if (fromTime == null || fromTime == undefined || toTime == null || toTime == undefined) {
      toTime = new Date();
      fromTime = new Date(+(new Date()) - (AppConfig.Settings.TABLE_CALENDAR_RANGE * 24 * 3600 * 1000))
    }
    fromTime = new Date(fromTime.setHours(0, 0, 0, 0));
    toTime = new Date(toTime.setHours(23, 59, 59, 999));
    const params = new HttpParams()
      .set('reqType', reqType.toString())
      .set('status', status.toString())
      .set('fromTime', fromTime.toISOString())
      .set('toTime', toTime.toISOString());
    return this.http.get<Array<RequestInfo>>(`${api.url}${api.Request.Manage}`, { params });
  }

  CreateRequest(reqDetail: RequestInfo): Observable<RequestInfo> {
    return this.http.post<RequestInfo>(`${api.url}${api.Request.CreateRequest}`, reqDetail);
  }

  GetRequestDetail(id: string): Observable<ReqMedInfo> {
    return this.http.get<ReqMedInfo>(`${api.url}${api.Request.GetRequestDetail}/${id}`);
  }

  GetHistory(reqType: number, status: number, fromTime: Date, toTime: Date): Observable<RequestInfo[]> {
    if (fromTime == null || fromTime == undefined || toTime == null || toTime == undefined) {
      toTime = new Date();
      fromTime = new Date(+(new Date()) - (AppConfig.Settings.TABLE_CALENDAR_RANGE * 24 * 3600 * 1000))
    }
    fromTime = new Date(fromTime.setHours(0, 0, 0, 0));
    toTime = new Date(toTime.setHours(23, 59, 59, 999));
    const params = new HttpParams()
      .set('reqType', reqType.toString())
      .set('status', status.toString())
      .set('fromTime', fromTime.toISOString())
      .set('toTime', toTime.toISOString());
    return this.http.get<RequestInfo[]>(`${api.url}${api.Request.History}`, { params });
  }

  ApproveRequest(reqDetail: RequestInfo): Observable<boolean> {
    return this.http.post<boolean>(`${api.url}${api.Request.ApproveRequest}/${reqDetail.Id}`, reqDetail);
  }

  RejectRequest(reqDetail: RequestInfo): Observable<boolean> {
    return this.http.post<boolean>(`${api.url}${api.Request.RejectRequest}/${reqDetail.Id}`, reqDetail);
  }

  deleteRequest(reqDetail: RequestInfo): Observable<boolean> {
    return this.http.post<boolean>(`${api.url}${api.Request.DeleteRequest}/${reqDetail.Id}`, null);
  }

  GetSummaryOfWeek(): Observable<SummaryInfo[]> {
    return this.http.get<SummaryInfo[]>(`${api.url}${api.Request.Request}/SummaryofWeek`);
  }

  GetSummaryOfPending(): Observable<SummaryInfo> {
    return this.http.get<SummaryInfo>(`${api.url}${api.Request.Request}/SummaryOfPending`);
  }

  GetAccessCount(): Observable<SummaryInfo[]> {
    return this.http.get<SummaryInfo[]>(`${api.url}${api.Admin.Admin}/AccessCount`);
  }

  GetUserActivities(): Observable<DataInfo[]> {
    return this.http.get<DataInfo[]>(`${api.url}${api.Admin.Admin}/UserActivities`);
  }

  Import(file: Temp): Observable<MedicalRecordInfo[]> {
    return this.http.post<MedicalRecordInfo[]>(`${api.url}/File/Import`, file);
  }

  Export(): Observable<any> {
    return this.http.get<any>(`${api.url}/File/Export`, { responseType: 'arraybuffer' as 'json', });
  }

}

